/* eslint-disable no-console */
import {
  Wrap,
  ToolOptions,
  DrawOptions,
  ModalBody,
  StyledDraggableItem,
  TabsWrapper,
  CSVImport,
  ImportButton,
  CsvFile,
} from './styles';

import geoAlert from 'services/utils/alert';
import geoConfirm from 'services/utils/confirm';
import { sizeConvert } from 'services/utils/converters';
import Coordinate from 'services/utils/Coordinate';

import EditableData from './components/EditableData';
import separatorsList from './services/separatorsList';
import sridList, { typeOptions, timezoneOptions } from './services/sridList';
import toolOptionsReducer, {
  initialToolOptionsState,
} from './services/toolOptionsReducer';
import toolReducer, { initialToolState } from './services/toolReducer';

import MaskedTextField from '@map/components/Form/components/MaskedTextField';
import Icon from '@map/components/Icons';
import SimpleModal from '@map/components/SimpleModal';
import ButtonTooltip from '@map/components/ToolBar/components/ButtonTooltip';
import featureContextMenu from '@map/services/utils/featureContextMenu';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import SelectMui from '@material-ui/core/Select';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import TextField from '@material-ui/core/TextField';
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
import FileInput from 'components/FileInput';
/**
 * useReducer é um hook parecido com o useState, ele permite a logica
 * de estado personalizada, para acompanhar varios pedaços de estado
 * que dependem de logia complexa o useReducer é indicado.
 * 
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useRef permite que persista valores entre renderizações, ele pode
 * ser usado para armazenar um valor mutável que não causa uma nova
 * renderização quando atualizado e pode ser usado para acessar di-
 * retamente um elemento do DOM.
 * 
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 */
import { useReducer, useState, useEffect, useRef, useCallback } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
/**
 * ReactDOM é um pacote que fornece métodos específicos do DOM que podem
 * ser usados no nível superior do seu aplicativo e como uma saída de 
 * emergencia para sair do modelo React.
 */
import ReactDOM from 'react-dom';
import SwipeableViews from 'react-swipeable-views';
import SliderColorPicker from 'views/MapView/components/SliderColorPicker';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 * 
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 */
import { useMap, useModule } from 'views/MapView/hooks';

// ? Nos imports acima foi utilizado um componente de @adm, deve ser migrado, pois sua utilização é ampla

// Criando elemento para o createPortal, para resolver problemas de posicionamento do objeto arrastável
const portal = document.createElement('div');
portal.classList.add('draggable-portal');
document.body.appendChild(portal);

/**
 * Função responsável por inserir coordenadas com a latidude e longitude dos pontos a mão ou seja
 * escrevendo a lat e long dos pontos, também é possivel fazer o upload de arquivos CSV
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação se está ativo
 * @param {boolean} setIsActive Setar se esta ativo
 * @returns um modal para preencher com dados e marcar um ponto no mapa de acordo
 * com as coordenadas passadas.
 */
const DrawByCoords = ({ mapContext, isActive, setIsActive }) => {
  const { getElement } = useModule(); // Pegar elemento do módulo 
  const [toolState, toolDispatch] = useReducer(toolReducer, { // Reducer para ferramentas
    ...initialToolState,
    featureType:
      getElement(DrawByCoords.properties.id)?.configuracao?.initialType ||
      'Point',
  });
  const [toolOptionsState, toolOptionsDispatch] = useReducer( // Reducer para opções de ferramentas 
    toolOptionsReducer, // Reducer para opções de ferramentas
    initialToolOptionsState // 
  );



  // Estados de SUBMENU
  const [anchorToolOptions, setAnchorToolOptions] = useState(null);

  const [drawOptionsIsOpened, setDrawOptionsIsOpened] = useState(false);
  const [anchorDrawOptions, setAnchorDrawOptions] = useState(null);
  const toogleDrawOptions = (event) => {
    setDrawOptionsIsOpened(!drawOptionsIsOpened);
    setAnchorDrawOptions(anchorDrawOptions ? null : event.currentTarget);
  };

  //Estado das Tabs
  const [activeTab, setActiveTab] = useState(0); // 0 = Coordenadas, 1 = Arquivo

  const closeDrawOptions = (event) => { // Fechar opções de desenho
    setDrawOptionsIsOpened(false);
    setAnchorDrawOptions(null);
  };

  const handleChangeTabs = (value) => {
    setActiveTab(value);
  };

  useEffect(() => {
    if (!isActive) {
      setAnchorToolOptions(null);
      closeDrawOptions();
      toolDispatch({ type: 'deleteAllFeatures', payload: { silent: true } });
      toolDispatch({ type: 'resetState' });
      toolOptionsDispatch({ type: 'resetState', payload: { all: true } });
    }
  }, [isActive]);

  useEffect(() => {
    if (toolState.coordsList.length <= 1) {
      setDrawOptionsIsOpened(false);
      setAnchorDrawOptions(null);
    }
  }, [toolState.coordsList, toolState.coordsList.length]);

  // Controlando inputs
  const longitudeInput = useRef(null); // Referencia para o input de longitude
  const latitudeInput = useRef(null); // Referencia para o input de latitude

  const mapCtx = useMap();
  const { map } = mapCtx;

  // Se quiser escutar a remoção de features pelo clique com botão direito essa é a função
  /* Alterar de switch para if pois switch so deve ser usado caso tenha mais
  de 3 casos, alterar somente apos correção de usabilidade. */
  const contextMenuListener = (event, payload) => {
    switch (event) {
      case 'ctxmenu:featureremoved':
        toolDispatch({ type: 'deleteAllFeatures', payload: { silent: true } });        
        return payload;
      default:
        return;
    }
    /* if(event === 'ctxmenu:featureremoved') {
      toolDispatch({
        type: 'deleteAllFeatures',
        payload: { silent: true},
      })
      return payload;
    } */
  };

  const listenToUpdates = ({ layer }) => {
    layer.on('pm:markerdragend', (e) => {
      const { target } = e;
      // Condicional necessária pois em polígonos temos que buscar o primeiro item do array, já nas linhas o array é único
      const latLongs = Array.isArray(target._latlngs[0])
        ? target._latlngs[0]
        : target._latlngs;
      const targetCoords = latLongs.reduce((acc, cur) => {
        return [...acc, { lat: cur.lat.toString(), lng: cur.lng.toString() }];
      }, []);
      toolDispatch({
        type: 'setCoords',
        payload: {
          coordsList: targetCoords,
          type: toolOptionsState.type,
        },
      });
    });

    layer.on('contextmenu', (e) => {
      const { originalEvent } = e;
      featureContextMenu({
        selectedLayer: layer,
        anchorPosition: {
          mouseX: originalEvent.clientX - 2,
          mouseY: originalEvent.clientY - 4,
        },
        listener: contextMenuListener,
        features: [layer],
        map,
      });
    });
  };

  const checkDisabledInsertButton = () => {
    let disabled = true;
    if (activeTab === 1) {
      if (
        toolOptionsState.type &&
        toolOptionsState.type.csv &&
        toolOptionsState.csvRows &&
        toolOptionsState.latColumn &&
        toolOptionsState.lngColumn
      ) {
        disabled = false;
      }
    } else {
      disabled = false;
    }
    return disabled;
  };

  const checkGeometryLimit = useCallback(
    (layerToCheck) => {
      let geometryLimit = getElement('CPN-TB-D-DRAW')?.configuracao
        .geometryLimit;
      if (geometryLimit) {
        let layerArea = turf.area(layerToCheck);
        let intersectResult = turf.intersect(layerToCheck, geometryLimit);
        let intersectArea = intersectResult ? turf.area(intersectResult) : 0;
        if ((100 / layerArea) * intersectArea < 90) {
          geoAlert({
            message:
              getElement('CPN-TB-D-DRAW')?.configuracao.geometryLimitMessage ||
              'A geometria deve estar contida dentro do limite!',
          });
          return false;
        }
      }
      return true;
    },
    [getElement]
  );

  const DraggablePortalItem = ({
    provided,
    index,
    toolStateOfDraggable,
    toolOptionsStateOfDraggable,
    listenToUpdates,
    lat,
    lng,
    zone,
    map,
  }) => {

    let coords = new Coordinate(
      [lng, lat],
      zone,
      toolOptionsStateOfDraggable.type.value,
      'SIRGAS2000'
    );
    return (
      <StyledDraggableItem
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        onMouseDown={(e) => e.stopPropagation()}
        className="draggable_coords"
      >
        <div className="left_options">
          <Icon i="map-grabarea" />
        </div>
        <div>{index + 1}</div>
        <EditableData
          label={'Latitude'}
          value={toolStateOfDraggable.coordsListRaw[index].lat}
          id={`editable_data_lat_${index}`}
          toolOptionsState={toolOptionsStateOfDraggable}
          onBlur={(latValue) => {
            toolDispatch({
              type: 'setLat',
              payload: {
                index,
                lat: latValue,
                type: toolOptionsStateOfDraggable.type,
                update: true,
                map,
                listenToUpdates,
              },
            });
          }}
        >
          {coords.toString().coords[1]}
        </EditableData>
        <EditableData
          label={'Longitude'}
          value={toolStateOfDraggable.coordsListRaw[index].lng}
          id={`editable_data_lng_${index}`}
          toolOptionsState={toolOptionsStateOfDraggable}
          lat={false}
          onBlur={(lngValue) => {
            toolDispatch({
              type: 'setLng',
              payload: {
                index,
                lng: lngValue,
                type: toolOptionsStateOfDraggable.type,
                update: true,
                map,
                listenToUpdates,
              },
            });
          }}
        >
          {coords.toString().coords[0]}
        </EditableData>

        <div className="right_options">
          <button
            onClick={() =>
              toolDispatch({
                type: 'flyTo',
                payload: {
                  map,
                  lat: coords.getDD('WGS84')[1],
                  lng: coords.getDD('WGS84')[0],
                },
              })
            }
          >
            <Icon i="map-toolbar-boundfocus" />
          </button>
          <button
            onClick={() =>
              toolDispatch({
                type: 'removeCoords',
                payload: { map, index, listenToUpdates },
              })
            }
          >
            <Icon i="map-toolbar-smalltrash" />
          </button>
        </div>
      </StyledDraggableItem>
    );
  };

  /* Parte responsavel por manter o scroll que a div 
  dentro do modal de adicionar coordenadas possui,
  sempre no final da div. */

  const [stateScroll, setStateScroll] = useState(false)
  const element = document.querySelector("#coordinatesCreated")
  const divHeight = element?.scrollHeight  
  
  useEffect(() => {
    if(element){
      element.scrollTo(0, divHeight)  
    }
    setStateScroll(false)
  }, [stateScroll, element, divHeight]);

  return (
    <Wrap>
      <ButtonTooltip
        tooltip={DrawByCoords.properties.alias}
        description={DrawByCoords.properties.description}
        onClick={(e) => {
          setIsActive(!isActive);
          setAnchorToolOptions(anchorToolOptions ? null : e.currentTarget);
        }}
        tooltipDisabled={isActive}
        active={isActive}
      >
        <Icon i="map-toolbar-drawbycoords" />
      </ButtonTooltip>
      <ToolOptions open={isActive} anchorEl={anchorToolOptions}>
        <ButtonTooltip
          tooltip="Adicionar Coordenadas"
          activeWithBgColor
          className = "btnActions"
          onClick={() => {
            toolDispatch({ type: 'openModal' });
            toolDispatch({ type: 'resetModalRelativePosition' });
            toolDispatch({ type: 'setModalState', payload: 'add' });
            closeDrawOptions();
          }}
        >
          <Icon i="map-toolbar-plus" />
        </ButtonTooltip>
        {getElement(DrawByCoords.properties.id)?.configuracao
          ?.geometryConvertion !== false && (
          <ButtonTooltip
            tooltip="Converter Geometria"
            activeWithBgColor
            style={{width: "31px", height: "40px"}}
            onClick={toogleDrawOptions}
            disabled={toolState.coordsList.length <= 1}
          >
            <Icon i="map-createDrawing"/>
          </ButtonTooltip>
        )}
        <ButtonTooltip
          tooltip="Lista de Coordenadas"
          activeWithBgColor
          className = "btnActions"
          onClick={() => {
            toolDispatch({ type: 'openModal' });
            toolDispatch({ type: 'resetModalRelativePosition' });
            toolDispatch({ type: 'setModalState', payload: 'reorder' });
            closeDrawOptions();
          }}
        >
          <Icon i="map-toolbar-list" />
        </ButtonTooltip>
        <div className = "lineSide">
        </div>
        <ButtonTooltip
          tooltip="Limpar"
          activeWithBgColor
          className = "btnActions"
          onClick={() => {
            geoConfirm({
              message: 'A(s) geometria(s) será(ão) apagadas. Deseja continuar?',
              callback: (confirmed) => {
                if (confirmed) {
                  toolDispatch({
                    type: 'deleteAllFeatures',
                    payload: { silent: true },
                  });
                  closeDrawOptions();
                }
              },
            });
          }}
        >
          <Icon i="map-toolbar-trash" />
        </ButtonTooltip>
        <ButtonTooltip
          tooltip="Confirmar Criação"
          activeWithBgColor
          style={{width: "31px", height: "40px"}}
          onClick={() => {
            let checkLimit = true;
            toolState.features.forEach((f) => {
              if (!checkGeometryLimit(f.toGeoJSON())) checkLimit = false;
            });
            if (checkLimit) {
              toolDispatch({ type: 'openSaveModal' });
              closeDrawOptions();
            }
          }}
          disabled={toolState.coordsList.length < 1}
        >
          <Icon i="map-toolbar-check" />
        </ButtonTooltip>
      </ToolOptions>
      <DrawOptions open={drawOptionsIsOpened} anchorEl={anchorDrawOptions}>      
      {getElement(DrawByCoords.properties.id)?.configuracao.lineConvertion && (
        <ButtonTooltip
          tooltip="Gerar linhas"
          activeWithBgColor
          onClick={() => {
            toolDispatch({
              type: 'transformToLines',
              payload: { map, listenToUpdates },
            });
          }}
          hide={toolState.featureType === 'Line'}
        >
          <Icon i="map-toolbar-line" />
        </ButtonTooltip>
      )}
      {getElement(DrawByCoords.properties.id)?.configuracao.poligonConvertion && (
        <ButtonTooltip
          tooltip="Gerar polígono"
          activeWithBgColor
          onClick={() => {
            toolDispatch({
              type: 'transformToPolygon',
              payload: { map, listenToUpdates },
            });
          }}
          hide={toolState.featureType === 'Polygon'}
        >
          <Icon i="map-toolbar-polygon" />
        </ButtonTooltip>
      )}
      {getElement(DrawByCoords.properties.id)?.configuracao.pointConvertion && (
        <ButtonTooltip
          tooltip="Gerar pontos"
          activeWithBgColor
          onClick={() => {
            toolDispatch({
              type: 'transformToPoints',
              payload: { map },
            });
          }}
          hide={toolState.featureType === 'Point'}
        >
          <Icon i="map-toolbar-marker" />
        </ButtonTooltip>
      )}
      </DrawOptions>
      <SimpleModal
        title={
          toolState.modalState === 'add'
            ? 'Inserir Coordenadas'
            : 'Lista de Coordenadas'
        }
        open={toolState.displayModal}
        onClose={(type) => {
          if (type !== 'clickAway') {
            toolOptionsDispatch({ type: 'resetState' });
            toolDispatch({ type: 'closeModal' });
          }
        }}
        customHeader={
          toolState.modalState === 'add' ? (
            <TabsWrapper>
              <Tabs value={activeTab} onChange={(e, v) => handleChangeTabs(v)}>
                <Tab label="Coordenadas " />
                <Tab label="Arquivo CSV" />
              </Tabs>
              <hr />
            </TabsWrapper>
          ) : undefined
        }        
        viewWidth={400}
      >
        {toolState.modalState === 'add' ? (
          <>
            <SwipeableViews index={activeTab} onChangeIndex={handleChangeTabs}>
              <ModalBody >
                <p className="text" style={{ margin: '0 0 8px' }}>
                  As coordenadas devem estar referenciadas no SIRGAS 2000.
                </p>
                <div className="selects_grid">
                  <FormControl variant="outlined" margin="dense">
                    {(!toolOptionsState.type || toolOptionsState.type.csv) && (
                      <InputLabel id="coord-type-label" shrink={false}>
                        {toolOptionsState.type.csv
                          ? toolOptionsState.type.label
                          : 'Tipo'}
                      </InputLabel>
                    )}
                    <SelectMui
                      labelId="coord-type-label"
                      value={toolOptionsState.type}
                      onChange={(e) => {
                        toolOptionsDispatch({
                          type: 'setType',
                          payload: e.target.value,
                        });
                      }}
                      disabled={
                        toolOptionsState.savedData.length ||
                        toolState.coordsList.length
                      }
                      MenuProps={{ style: { zIndex: 1700 } }}
                      IconComponent={(props) => (
                        <Icon
                          i="map-chevrondown"
                          style={{ top: 'auto', right: 12 }}
                          {...props}
                        />
                      )}
                    >
                      {typeOptions.map((t, i) => (
                        <MenuItem value={t} key={i}>
                          {t.label}
                        </MenuItem>
                      ))}
                    </SelectMui>
                  </FormControl>                  
                  <FormControl variant="outlined" margin="dense">
                    {!toolOptionsState.timezone && (
                      <InputLabel id="coord-fuso" shrink={false}>
                        Fuso
                      </InputLabel>
                    )}
                    <SelectMui 
                      labelId="coord-fuso"
                      value={toolOptionsState.timezone}
                      onChange={(e) => {
                        toolOptionsDispatch({
                          type: 'setTimezone',
                          payload: e.target.value,
                        });
                      }}
                      disabled={!toolOptionsState.timezoneIsEnabled}
                      MenuProps={{ style: { zIndex: 1700 } }}
                      IconComponent={(props) => (
                        <Icon
                          i="map-chevrondown"
                          style={{ top: 'auto', right: 12 }}
                          {...props}
                        />
                      )}
                    >
                      {timezoneOptions.map((t, i) => (
                        <MenuItem value={t} key={i}>
                          {t.label}
                        </MenuItem>
                      ))}
                    </SelectMui>
                  </FormControl>                  
                </div>
                <div className='coordinatesCreated' id='coordinatesCreated'>
                  {toolOptionsState.savedData.map((coords, idx) => (
                    <div
                      className={`coords_grid ${
                        toolOptionsState.type.value === 'UTM' && 'reverse'
                      }`}
                      key={idx}
                    >
                      <MaskedTextField
                        id={`latitude_${idx}`}
                        label={toolOptionsState.type.fieldLabels.lat}
                        variant="outlined"
                        size="small"
                        value={coords.lat}
                        inputProps={{
                          tabIndex:
                            toolOptionsState.type.value === 'UTM'
                              ? ((idx + 1) * 2).toString()
                              : '0',
                        }}
                        mask={toolOptionsState.type.mask.lat}
                        placeholder={toolOptionsState.type.placeholder.lat}
                        initialActive={true}
                        guide={false}
                        endAdornment={ // serve para adicionar o símbolo de grau no final do campo
                          <InputAdornment position="end">
                            {toolOptionsState.type.endAdornment}
                          </InputAdornment>
                        }
                        onChange={(e) => {
                          if (
                            e.target.value.length > 1 ||
                            toolOptionsState.type.value === 'UTM'
                          )
                            toolOptionsDispatch({
                              type: 'setLatitude',
                              payload: { index: idx, lat: e.target.value },
                            });
                        }}
                      />
                      <MaskedTextField
                        id={`longitude_${idx}`}
                        label={toolOptionsState.type.fieldLabels.lng}
                        variant="outlined"
                        size="small"
                        value={coords.lng}
                        inputProps={{
                          tabIndex:
                            toolOptionsState.type.value === 'UTM'
                              ? ((idx + 1) * 2 - 1).toString()
                              : '0',
                        }}
                        mask={toolOptionsState.type.mask.lng}
                        placeholder={toolOptionsState.type.placeholder.lng}
                        initialActive={true}
                        guide={false}
                        endAdornment={
                          <InputAdornment position="end">
                            {toolOptionsState.type.endAdornment}
                          </InputAdornment>
                        }
                        onChange={(e) => {
                          if (
                            e.target.value.length > 1 ||
                            toolOptionsState.type.value === 'UTM'
                          )
                            toolOptionsDispatch({
                              type: 'setLongitude',
                              payload: { index: idx, lng: e.target.value },
                            });
                        }}
                      />
                    </div>
                  ))}
                  <div
                    className={`coords_grid ${
                      toolOptionsState.type.value === 'UTM' && 'reverse'
                    }`}
                  >
                    <MaskedTextField
                      ref={latitudeInput}
                      id={`latitude_${toolOptionsState.savedData?.length + 1}`}
                      label={toolOptionsState.type.fieldLabels.lat}
                      variant="outlined"
                      size="small"
                      value={toolOptionsState.actualData.lat}
                      inputProps={{
                        tabIndex:
                          toolOptionsState.type.value === 'UTM'
                            ? (
                                (toolOptionsState.savedData?.length + 1) *
                                2
                              ).toString()
                            : '0',
                      }}
                      mask={toolOptionsState.type.mask.lat}
                      placeholder={toolOptionsState.type.placeholder.lat}
                      guide={false}
                      endAdornment={
                        <InputAdornment position="end">
                          {toolOptionsState.type.endAdornment}
                        </InputAdornment>
                      }
                      onChange={(e) => {
                        if (
                          e.target.value.length > 1 ||
                          toolOptionsState.type.value === 'UTM'
                        )
                          toolOptionsDispatch({
                            type: 'setLatitude',
                            payload: e.target.value,
                          });
                      }}
                    />
                    <MaskedTextField
                      ref={longitudeInput} 
                      id={`longitude_${toolOptionsState.savedData?.length + 1}`}
                      label={toolOptionsState.type.fieldLabels.lng}
                      variant="outlined"
                      size="small"
                      value={toolOptionsState.actualData.lng}
                      inputProps={{
                        tabIndex:
                          toolOptionsState.type.value === 'UTM'
                            ? (
                                (toolOptionsState.savedData?.length + 1) * 2 -
                                1
                              ).toString()
                            : '0',
                      }}
                      mask={toolOptionsState.type.mask.lng}
                      placeholder={toolOptionsState.type.placeholder.lng}
                      guide={false} // Serve para não mostrar o underline
                      endAdornment={ // Serve para colocar o N, S, E, W
                        <InputAdornment position="end">
                          {toolOptionsState.type.endAdornment}
                        </InputAdornment>
                      }
                      onChange={(e) => {
                        if (
                          e.target.value.length > 1 ||
                          toolOptionsState.type.value === 'UTM'
                        )
                          toolOptionsDispatch({
                            type: 'setLongitude',
                            payload: e.target.value,
                          });
                      }}
                      // error={Boolean(saveLayerError)}
                      // helperText={saveLayerError}
                    />
                  </div>
                  <button
                    className='btnAddCoord'
                    onClick={() => {
                      setStateScroll(true)
                      toolOptionsDispatch({
                        type: 'addCoordsField',
                      });
                      if (toolOptionsState.type.value === 'UTM') {
                        longitudeInput.current.querySelector('input').focus();
                      } else {
                        latitudeInput.current.querySelector('input').focus();
                      }
                    }}
                    tabIndex={
                      toolOptionsState.type.value === 'UTM'
                        ? (
                            (toolOptionsState.savedData?.length + 1) * 2 +
                            1
                          ).toString()
                        : '0'
                    }
                    disabled={
                      !(
                        toolOptionsState.actualData.lng &&
                        toolOptionsState.actualData.lat
                      )
                    }
                  >
                    Adicionar
                  </button>
                </div>
              </ModalBody>
              <CSVImport>
                <p className="text" style={{ margin: '0 0 16px' }}>
                  As coordenadas devem estar referenciadas no SIRGAS 2000.
                </p>
                <div className="flex-row">
                  {toolOptionsState.csvFile && toolOptionsState.csvRows ? (
                    <CsvFile>
                      <Icon i="map-csv" />
                      <div className="file-info">
                        <p>
                          <b>
                            {toolOptionsState.csvFile.name.replace(/\..*$/, '')}
                          </b>
                          {toolOptionsState.csvFile.name.match(/\..*$/)}
                        </p>
                        <p>{sizeConvert(toolOptionsState.csvFile.size)} </p>
                      </div>
                      <button
                        className="remove-button"
                        onClick={() => {
                          toolOptionsDispatch({
                            type: 'setCsvFile',
                            payload: null,
                          });
                          toolOptionsDispatch({
                            type: 'setCsvRows',
                            payload: [],
                          });
                        }}
                      >
                        <Icon i="map-trash" />
                      </button>
                    </CsvFile>
                  ) : (
                    <FileInput
                      accept=".csv"
                      onChange={(newFile) => {
                        let fr = new FileReader();
                        fr.onloadend = (e) => {
                          let rows = e.target.result.split(/\n/);
                          rows = rows.filter((r) => (r ? true : false));
                          if (rows.length > 1) {
                            toolOptionsDispatch({
                              type: 'setCsvFile',
                              payload: newFile,
                            });
                            toolOptionsDispatch({
                              type: 'setCsvRows',
                              payload: rows,
                            });
                          } else {
                            geoAlert({
                              message:
                                'Não foi possível carregar o arquivo. Arquivo incompleto.',
                            });
                          }
                        };
                        fr.readAsText(newFile);
                      }}
                      style={{ margin: 0, width: '100%' }}
                      variant="button"
                      extensionCheckMsg="Não foi possível inserir o arquivo. Arquivo com formato não permitido."
                    />
                  )}
                </div>
                <div className="flex-row">
                  <div style={{ width: 170 }}>
                    <FormControl variant="outlined" margin="dense" fullWidth>
                      {!toolOptionsState.separator && (
                        <InputLabel id="csv-separator" shrink={false}>
                          Separador
                        </InputLabel>
                      )}
                      <SelectMui
                        labelId="csv-separator"
                        value={toolOptionsState.separator}
                        onChange={(e) => {
                          toolOptionsDispatch({
                            type: 'setSeparator',
                            payload: e.target.value,
                          });
                        }}
                        MenuProps={{ style: { zIndex: 1700 } }}
                        IconComponent={(props) => (
                          <Icon
                            i="map-chevrondown"
                            style={{ top: 'auto', right: 12 }}
                            {...props}
                          />
                        )}
                      >
                        {separatorsList.map((s, i) => (
                          <MenuItem value={s} key={i}>
                            {s.label}
                          </MenuItem>
                        ))}
                      </SelectMui>
                    </FormControl>
                    {/* <Select options={separatorsList} placeholder="Separador" /> */}
                  </div>
                  {toolOptionsState.separator?.value === 'outro' && (
                    <div style={{ width: 80, marginLeft: 24 }}>
                      <TextField
                        id="other-separator"
                        placeholder="Digitar"
                        variant="outlined"
                        size="small"
                        fullWidth
                        inputProps={{ maxlength: 1 }}
                        value={toolOptionsState.otherSeparator}
                        onChange={(e) => {
                          toolOptionsDispatch({
                            type: 'setOtherSeparator',
                            payload: e.target.value,
                          });
                        }}
                      />
                    </div>
                  )}
                </div>
                <div style={{ marginBottom: 24, width: 281 }}>
                  <FormControl variant="outlined" margin="dense" fullWidth>
                    {!(toolOptionsState.type && toolOptionsState.type.csv) && (
                      <InputLabel id="csv-coord-type" shrink={false}>
                        Tipo de coordenada
                      </InputLabel>
                    )}
                    <SelectMui
                      labelId="csv-coord-type"
                      value={toolOptionsState.type}
                      disabled={
                        toolOptionsState.savedData.length ||
                        toolState.coordsList.length
                      }
                      onChange={(e) => {
                        let value = e.target.value;
                        toolOptionsDispatch({
                          type: 'setType',
                          payload: value,
                        });
                        value.zone &&
                          toolOptionsDispatch({
                            type: 'setTimezone',
                            payload: value.zone,
                          });
                      }}
                      MenuProps={{ style: { zIndex: 1700 } }}
                      IconComponent={(props) => (
                        <Icon
                          i="map-chevrondown"
                          style={{ top: 'auto', right: 12 }}
                          {...props}
                        />
                      )}
                    >
                      {sridList.map((s, i) => (
                        <MenuItem value={s} key={i}>
                          {s.csvLabel}
                        </MenuItem>
                      ))}
                    </SelectMui>
                  </FormControl>
                  {/* <Select options={sridList} placeholder="Tipo de coordenada" /> */}
                </div>

                <div className="flex-row" style={{ flexWrap: 'wrap' }}>
                  <label
                    className="text"
                    style={{ flexGrow: 1, width: '100%', marginBottom: 5 }}
                  >
                    Selecione as colunas referentes a:
                  </label>
                  <div style={{ width: 118, marginRight: 24 }}>
                    <FormControl variant="outlined" margin="dense" fullWidth>
                      {!toolOptionsState.latColumn && (
                        <InputLabel id="csv-column-lat" shrink={false}>
                          {toolOptionsState.type.fieldLabels.lat}
                        </InputLabel>
                      )}
                      <SelectMui
                        labelId="csv-column-lat"
                        value={toolOptionsState.latColumn}
                        disabled={!toolOptionsState.csvColumns.length}
                        onChange={(e) => {
                          toolOptionsDispatch({
                            type: 'setLatColumn',
                            payload: e.target.value,
                          });
                        }}
                        MenuProps={{ style: { zIndex: 1700 } }}
                        IconComponent={(props) => (
                          <Icon
                            i="map-chevrondown"
                            style={{ top: 'auto', right: 12 }}
                            {...props}
                          />
                        )}
                      >
                        {toolOptionsState.csvColumns.map((c,i) =>
                          c !== toolOptionsState.lngColumn ? (
                            <MenuItem key={i} value={c}>{c.label}</MenuItem>
                          ) : null
                        )}
                      </SelectMui>
                    </FormControl>
                    {/* <Select
                      options={[{ label: 'Teste', value: 'Teste' }]}
                      placeholder="Latitude"
                    /> */}
                  </div>
                  <div style={{ width: 118 }}>
                    <FormControl variant="outlined" margin="dense" fullWidth>
                      {!toolOptionsState.lngColumn && (
                        <InputLabel id="csv-column-lng" shrink={false}>
                          {toolOptionsState.type.fieldLabels.lng}
                        </InputLabel>
                      )}
                      <SelectMui
                        labelId="csv-column-lng"
                        value={toolOptionsState.lngColumn}
                        disabled={!toolOptionsState.csvColumns.length}
                        onChange={(e) => {
                          toolOptionsDispatch({
                            type: 'setLngColumn',
                            payload: e.target.value,
                          });
                        }}
                        MenuProps={{ style: { zIndex: 1700 } }}
                        IconComponent={(props) => (
                          <Icon
                            i="map-chevrondown"
                            style={{ top: 'auto', right: 12 }}
                            {...props}
                          />
                        )}
                      >
                        {toolOptionsState.csvColumns.map((c,i) =>
                          c !== toolOptionsState.latColumn ? (
                            <MenuItem key={i} value={c}>{c.label}</MenuItem>
                          ) : null
                        )}
                      </SelectMui>
                    </FormControl>
                    {/* <Select
                      options={[{ label: 'Teste', value: 'Teste' }]}
                      placeholder="Longitude"
                    /> */}
                  </div>
                </div>
              </CSVImport>
            </SwipeableViews>
            <div style={{ textAlign: 'center' }}>
              <ImportButton
                variant="contained"
                color="primary"
                component="div"
                disabled={checkDisabledInsertButton()}
                tabIndex={
                  toolOptionsState.type.value === 'UTM'
                    ? (
                        (toolOptionsState.savedData?.length + 1) * 2 +
                        2
                      ).toString()
                    : '0'
                }
                onClick={() => {
                  const insertCoords = (csv = false) =>
                    toolOptionsDispatch({
                      type: 'insertCoords',
                      callback: (paramToolState) => {
                        
                        if (paramToolState) {
                 
                          toolDispatch({
                            type: 'addPoints',
                            payload: {
                              listOfCoords: paramToolState,
                              type: toolOptionsState.type,
                              listenToUpdates,
                              map,
                              csv,
                            },
                          });
                          toolOptionsDispatch({ type: 'resetState' });
                          toolDispatch({ type: 'closeModal' });
                        }
                      },
                    });
                  if (activeTab === 1) {
                    toolOptionsDispatch({
                      type: 'importCsvCoords',
                      callback: () => insertCoords(true),
                    });
                  } else {
                    insertCoords();
                  }
                }}
              >
                Inserir
              </ImportButton>
            </div>
          </>
        ) : (
          <ModalBody>
            <header className="pseudo_reorder_table">
              <div></div>
              <div>{toolOptionsState.type.fieldLabels.lat}</div>
              <div>{toolOptionsState.type.fieldLabels.lng}</div>
            </header>
            <DragDropContext
              onDragEnd={(result) =>
                toolDispatch({
                  type: 'reorderCoords',
                  payload: {
                    result,
                    map,
                    listenToUpdates,
                  },
                })
              }
            >
              <div className="dorpable-list">
                <Droppable droppableId="droppable">
                  {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                      {toolState.coordsListRaw.map(
                        ({ lat, lng, zone }, index) => (
                          <Draggable
                            key={`${lat}${lng}-${index}`}
                            draggableId={`${lat}${lng}-${index}`}
                            index={index}
                          >
                            {(paramProvided, snapshot) => {
                              const child = (
                                <DraggablePortalItem
                                  provided={paramProvided}
                                  index={index}
                                  toolStateOfDraggable={toolState}
                                  toolOptionsStateOfDraggable={toolOptionsState}
                                  listenToUpdates={listenToUpdates}
                                  lat={lat}
                                  lng={lng}
                                  zone={zone}
                                  map={map}
                                />
                              );
                              return snapshot.isDragging
                                ? ReactDOM.createPortal(child, portal)
                                : child;
                            }}
                          </Draggable>
                        )
                      )}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
            </DragDropContext>
            <footer>
              <button
                className="restore-button"
                disabled={
                  !(
                    toolOptionsState.csvCoords.length && toolState.coordsChanged
                  )
                }
                onClick={() => {
                  const insertCoords = () => {
                    toolOptionsDispatch({
                      type: 'insertCoords',
                      callback: (paramToolState) => {
                        if (paramToolState) {
                          toolDispatch({
                            type: 'addPoints',
                            payload: {
                              listOfCoords: paramToolState,
                              type: toolOptionsState.type,
                              listenToUpdates,
                              map,
                              csv: true,
                              reset: true,
                            },
                          });
                        }
                      },
                    });
                    geoAlert({ message: 'Coordenadas restauradas!' });
                  };
                  geoConfirm({
                    message:
                      'Ao restaurar, todas inclusões/alterações serão retornadas para o estado inicial do CSV. Deseja continuar?',
                    callback: () =>
                      toolOptionsDispatch({
                        type: 'restoreCsvCoords',
                        callback: insertCoords,
                      }),
                  });
                }}
              >
                Restaurar
              </button>
            </footer>
          </ModalBody>
        )}
      </SimpleModal>
      <SimpleModal
        title="Salvar Camada"
        open={toolState.displaySaveModal}
        onClose={() => {
          toolDispatch({ type: 'closeSaveModal' });
        }}
      >
        <ModalBody id="save_modal_body">
          <TextField
            id="layer-name"
            label="Nome da camada"
            variant="outlined"
            size="small"
            fullWidth
            inputProps={{ maxlength: 70 }}
            value={toolState.layerNameToSave}
            onChange={(e) => {
              toolDispatch({
                type: 'setLayerNameToSave',
                payload: e.target.value,
              });
            }}
            error={Boolean(toolState.saveLayerNameError)}
            helperText={toolState.saveLayerNameError}
          />
          <SliderColorPicker
            geometryType={toolState.featureType}
            selectedSymbology={toolState.layerStyleToSave}
            onSelect={(style) =>
              toolDispatch({
                type: 'setLayerStyleToSave',
                payload: style,
              })
            }
          />
          <p style={{ marginLeft: 9 }}>
            Após salvar o desenho não será permitido editá-lo.
          </p>
          <div style={{ margin: '32px auto 0', width: '185.14px', textAlign: 'center' }}>
            <Button
              style={{width: '185px', height: '39px'}}
              variant="contained"
              color="primary"
              component="div"
              onClick={() => {
                toolDispatch({
                  type: 'saveAsLayer',
                  payload: {
                    mapContext: mapCtx,
                    callback: ({ error }) => {
                      error && console.error(error);
                      if (!error) {
                        setIsActive(false);
                        setDrawOptionsIsOpened(false);
                        setAnchorToolOptions(null);
                        setAnchorDrawOptions(null);
                      }
                    },
                  },
                });
              }}
            >
              Salvar
            </Button>
          </div>
        </ModalBody>
      </SimpleModal>
    </Wrap>
  );
};

DrawByCoords.properties = {
  id: 'CPN-TB-D-DRAW-COORDS',
  alias: 'Inserir Coordenadas',
  description:
    'Insere coordenadas geográficas, podendo converter em linhas ou polígonos.',
  configurable: true,
};

export default DrawByCoords;
